import { createRoute } from '@tanstack/react-router';
import { appRoute } from './parent-routes';
import PlaceholderPage from '@phrmpc/shared/components/PlaceholderPage';

const dashboardRoute = createRoute({
  getParentRoute: () => appRoute,
  path: 'dashboard',
  component: () => <PlaceholderPage title="Dashboard" />,
  staticData: {
    handle: { title: 'Dashboard' },
  },
});

export default dashboardRoute;
